export type SortByFn<M> = (a: M, b: M) => number;

export interface SortParams<Col extends string> {
  columnName: Col;
  direction: SortDirection;
}

export enum SortDirection {
  ASCENDING = "ascending",
  DESCENDING = "descending",
  NONE = "none"
}

export interface CycleDirectionOptions {
  includeNone?: boolean;
}

const defaultCycleDirectionOptions = {
  includeNone: true
};

export function cycleDirection(
  currDir: SortDirection,
  options: CycleDirectionOptions = defaultCycleDirectionOptions
): SortDirection {
  const mergedOptions = Object.assign(defaultCycleDirectionOptions, options);

  switch (currDir) {
    case SortDirection.NONE:
      return SortDirection.DESCENDING;
    case SortDirection.DESCENDING:
      return SortDirection.ASCENDING;
    case SortDirection.ASCENDING:
      if (mergedOptions.includeNone) {
        return SortDirection.NONE;
      } else {
        return SortDirection.DESCENDING;
      }
  }
}

export const sortDirectionToSqlMap = {
  [SortDirection.ASCENDING]: "desc",
  [SortDirection.DESCENDING]: "asc",
  [SortDirection.NONE]: "none"
};

export const sqlDirectionToSortDirectionMap = {
  [sortDirectionToSqlMap[SortDirection.ASCENDING]]: SortDirection.ASCENDING,
  [sortDirectionToSqlMap[SortDirection.DESCENDING]]: SortDirection.DESCENDING,
  [sortDirectionToSqlMap[SortDirection.NONE]]: SortDirection.NONE
};
